module.exports = __webpack_public_path__ + "static/media/cartagena-12.6b9af666.jpg";